// extracted by mini-css-extract-plugin
module.exports = {"largeIcon":"src-lib-app-components-elements-icons-icon-module__largeIcon--2M4j2","smallIcon":"src-lib-app-components-elements-icons-icon-module__smallIcon--Thl8q"};